import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import './componentes/utils/BarraAcessibilidade.css';
import VLibras from "@djpfs/react-vlibras";
import Cabecalho from "./componentes/Cabecalho";
import Inicio from "./componentes/Inicio";
import Footer from "./componentes/Footer";
import PaginaNaoEncontrada from "./componentes/404";
import ViewNoticia from "./componentes/ViewNoticia";
import SalaEmpreendedor from "./componentes/SalaEmpreendedor";
import Transparencia from "./componentes/Transparencia";
import Solicitacoes from "./componentes/rh/Solicitacoes";
import FichaFuncional from "./componentes/rh/FichaFuncional";
import ContraCheque from "./componentes/rh/ContraCheque";
import LeiPauloGustavo from "./componentes/leipaulogustavo";
import GurjaoPlus from "./componentes/app/GurjaoPlus";
import NotaFiscal from "./componentes/app/NotaFiscal";
import CodigoTributario from "./componentes/legislacao/CodigoTributario";
import Decretos from "./componentes/legislacao/Decretos";
import DiarioOficial from "./componentes/legislacao/DiarioOficial";
import LeisMunicipais from "./componentes/legislacao/Leismunicipais";
import LeiOrganica from "./componentes/legislacao/Leiorganica";
import Portarias from "./componentes/legislacao/Portarias";
import Editais from "./componentes/arquivos/Editais";
import LDO from "./componentes/arquivos/LDO";
import LOA from "./componentes/arquivos/LOA";
import RGF from "./componentes/arquivos/RGF";
import RREO from "./componentes/arquivos/RREO";

import IPTU from "./componentes/app/IPTU";
// import Financas from "./componentes/secretarias/Financas";
// import Educacao from "./componentes/secretarias/Educacao";
// import Administracao from "./componentes/secretarias/Administracao";
// import Cultura from "./componentes/secretarias/Cultura";
// import Saude from "./componentes/secretarias/Saude";
// import DesenvolvimentoRural from "./componentes/secretarias/DesenvolvimentoRural";
// import AssistenciaSocial from "./componentes/secretarias/AssistenciaSocial";
// import Prefeito from "./componentes/prefeitura/Prefeito";
// import VicePrefeito from "./componentes/prefeitura/VicePrefeito";
// import Rh from './componentes/secretarias/rh';
// import MeioAmbiente from './componentes/secretarias/MeioAmbiente';
// import Infraestrutura from './componentes/secretarias/Infraestrutura';
import OuvidoriaPage from "./componentes/prefeitura/Ouvidoria";
import LoadingScreen from 'react-loading-screen'
import Contratos from "./componentes/arquivos/Contratos";

import Frota from "./componentes/arquivos/Frota";
import TodasNoticias from "./componentes/TodasNoticias";
import Contato from './componentes/app/Contato';
import Licitacoes from './componentes/Licitacoes';


import Avisos from './componentes/Avisos';
import { FloatingWhatsApp } from 'react-floating-whatsapp';

import Quadro from './componentes/arquivos/Quadro';
import ProcessoSeletivo from './componentes/legislacao/Processoseletivo';
import FarmaciaBasica from './componentes/arquivos/FarmaciaBasica';
import ControleInterno from './componentes/legislacao/ControleInterno';

import AldirBlanc from './componentes/legislacao/aldir_blanc';

import { getDatabase, ref, get, onValue, runTransaction, serverTimestamp } from 'firebase/database';
import firebaseApp, { camara, KEY_REF } from './componentes/adm/admin/firebaseConfig';
import SaoJoao from './componentes/app/JoaoJoao';
import TicketDetails from './componentes/app/TicketDetail';
import HistoriaGurjaoPage from './componentes/prefeitura/Historia';
import ESICPage from './componentes/prefeitura/ESICPage';
import ServiceLetterPage from './componentes/prefeitura/CartaServico';
import LgpdInfoPage from './componentes/prefeitura/LGPD';
import GaleriaMidiaPage from './componentes/prefeitura/GaleriaMidiaPage ';
import PoliticaPrivacidadePage from './componentes/prefeitura/gurjaoplus';
import PCA from './componentes/arquivos/PCA';
import TabelaDiariasMunicipais from './componentes/utils/TabelaDiarias';
import Header from './componentes/utils/Header';
import ViewVereador from './componentes/ViewVereador';
import Requerimentos from './componentes/legislacao/Requerimentos';
import ProjetoDeLei from './componentes/legislacao/ProjetoDeLei';
import Mocoes from './componentes/legislacao/Mocoes';
import Pedidos from './componentes/legislacao/Pedidos';
import Mesadiretora from './componentes/legislacao/Mesadiretora';
import { passConfigToOtherComponent } from './componentes/adm/ConfigContext';

import ConcursoPublico from './componentes/arquivos/ConcursoPublico';
import Semanario from './componentes/arquivos/Semanario';
import ArqLicitacoes from './componentes/arquivos/ArquivoLicitacoes';
import ViewSecretario from './componentes/ViewSecretario';
import Atas from './componentes/legislacao/Atas';
import Pareceres from './componentes/legislacao/pareceres';
import Resolucoes from './componentes/legislacao/Resolucoes';
import Indicacoes from './componentes/legislacao/Indicacoes';
import Secretarios from './componentes/TodosSecretarios';
import ViewGestao from './componentes/ViewGestao';
import Vereadores from './componentes/legislacao/VereadoresGrid';
import PPA from './componentes/arquivos/PPA';
import EmendasParlamentares from './componentes/legislacao/EmendasParlamentares';
import GaleriaPresidentes from './componentes/legislacao/GaleriaPresidentes';
import Sessoes from './componentes/legislacao/Sessoes';
import DecretosLegislativos from './componentes/legislacao/DecretosLegislativos';
import Arquivos from './componentes/legislacao/Arquivo';
import DynamicPage from './componentes/legislacao/DynamicPage';
import Breadcrumb from './componentes/Breadcrumb';
import BarraAcessibilidade from './componentes/utils/BarraAcessibilidade';
import MapaDoSite from './componentes/MapaDoSite';
import PesquisaFlutuante from './componentes/utils/PesquisaFlutuante';

const database = getDatabase(firebaseApp);

const isLikelyBot = () => {
  const ua = navigator.userAgent.toLowerCase();
  const bots = [
    'bot', 'spider', 'crawler', 'headless', 'phantomjs', 'slurp',
    'googlebot', 'bingbot', 'yandexbot', 'baiduspider', 'duckduckbot',
    'facebookexternalhit', 'twitterbot', 'linkedinbot'
  ];
  return bots.some(b => ua.includes(b)) ||
    !navigator.languages ||           // bots muitas vezes não têm
    !window.screen?.width ||          // headless geralmente sem screen
    navigator.webdriver;              // Chrome headless flag
};

const fetchClientIP = async () => {
  try {
    const res = await fetch('https://api.ipify.org?format=json');
    const data = await res.json();
    return data.ip || 'unknown';
  } catch {
    try {
      // fallback
      const res2 = await fetch('https://ipapi.co/json/');
      const data2 = await res2.json();
      return data2.ip || 'unknown';
    } catch {
      return 'unknown';
    }
  }
};

function App() {
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const registerVisit = async () => {
      if (isLikelyBot()) {
        console.log("Acesso provavelmente de bot → ignorado");
        return;
      }

      const lastVisit = localStorage.getItem('lastVisitTime');
      const now = Date.now();

      if (lastVisit && now - parseInt(lastVisit, 10) < 30 * 60 * 1000) {
        // console.log("Visita já contada recentemente");
        return;
      }

      try {
        const ip = await fetchClientIP();
        // console.log(`Visitante legítimo detectado - IP: ${ip}`);

        const agora = new Date();
        const ano = agora.getFullYear().toString();
        const mes = String(agora.getMonth() + 1).padStart(2, '0');

        const db = getDatabase(firebaseApp);
        const path = `dashboards/views/${ano}/${mes}`;

        await runTransaction(ref(db, path), (current) => {
          if (!current) {
            return {
              count: 1,
              updated: serverTimestamp()
            };
          }

          return {
            ...current,
            count: (current.count || 0) + 1,
            updated: serverTimestamp(),
          };
        });

        localStorage.setItem('lastVisitTime', now.toString());

      } catch (err) {
        console.error("Erro ao registrar visita:", err);
      }
    };

    if (window.location.pathname === '/') {
      registerVisit();
    }
  }, []);

  useEffect(() => {
    const fetchConfig = async () => {
      setLoading(true);

      if (!KEY_REF) {
        console.error("KEY_REF não definido.");
        setLoading(false);
        return;
      }

      const cacheKey = `config_cache_${KEY_REF}`;
      const cacheTimestampKey = `config_timestamp_${KEY_REF}`;
      const cacheTimestamp = localStorage.getItem(cacheTimestampKey);
      const currentTime = Date.now();
      const cacheValid = cacheTimestamp && currentTime - cacheTimestamp < 3600000;


      if (cacheValid && localStorage.getItem(cacheKey)) {
        const cachedConfig = JSON.parse(localStorage.getItem(cacheKey));
        setConfig(cachedConfig);
        passConfigToOtherComponent(cachedConfig);
        setLoading(false);
        return;
      }

      try {
        const dbRef = ref(database, `config/`);
        const snapshot = await get(dbRef);

        if (snapshot.exists()) {
          const newConfig = snapshot.val();
          setConfig(newConfig);

          const configSizeKB = new TextEncoder().encode(JSON.stringify(newConfig)).length / 1024;

          localStorage.setItem(cacheKey, JSON.stringify(newConfig));
          localStorage.setItem(cacheTimestampKey, currentTime.toString());

          passConfigToOtherComponent(newConfig);
        } else {
          setConfig(null);
        }
      } catch (error) {
        console.error("Error fetching config:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, [KEY_REF]);

  if (loading) {
    return <LoadingScreen
      loading={true}
      bgColor='white'
      spinnerColor='#9ee5f8'
      textColor='#676767'
      logoSrc='/logo512.png'
    />
  }

  return (
    <Router>
      <BarraAcessibilidade />
      <PesquisaFlutuante />
      <Cabecalho config={config} />
      <Breadcrumb />
      {/* <Header/> */}


      <FloatingWhatsApp
        phoneNumber={config?.telefone}
        accountName={config?.orgaoNome}
        avatar="/logo512.png"
        statusMessage="Geralmente Responde em 30 minutos"
        allowEsc
        allowClickAway
        notification
        notificationSound="true"
        messageDelay="1"
        placeholder="Escreva uma mensagem..."
        chatMessage="Bem-vindos! Em que posso ajudar?"
        notificationDelay="10"
      />

      <VLibras forceOnload={true}></VLibras>


      <Routes>
        <Route path="/mapadosite" element={<MapaDoSite />} />
        <Route path="/vereadores/:id" element={<ViewVereador />} />
        <Route path="/vereadores" element={<Vereadores />} />
        {!camara && <Route path="/secretarios/:id" element={<ViewSecretario />} />}
        {!camara && <Route path="/prefeitura/:id" element={<ViewGestao />} />}
        <Route path="/" element={<Inicio config={config} />} />
        <Route path="/secretarios" element={<Secretarios config={config} />} />
        <Route path="/noticias/:titulo/:id" element={<ViewNoticia />} />
        <Route path="/noticias/todas" element={<TodasNoticias />} />
        <Route path="/transparencia" element={<Transparencia config={config} />} />
        {!camara && <Route path="/saladoempreendedor" element={<SalaEmpreendedor />} />}
        {!camara && <Route path="/leipaulogustavo" element={<LeiPauloGustavo />} />}
        <Route path="/avisos" element={<Avisos />} />
        & <Route path="/processo_seletivo" element={<ProcessoSeletivo />} />
        {!camara && <Route path="/rh/documentos" element={<Solicitacoes />} />}
        {!camara && <Route path="/rh/fichafuncional" element={<FichaFuncional />} />}
        <Route path="/rh/cc" element={<ContraCheque />} />
        {!camara && <Route path="/app/gurjaoplus" element={<GurjaoPlus />} />}
        {camara && <Route path="/app/sessoes" element={<Sessoes />} />}
        {!camara && <Route path="/app/gurjaoplus/politicadeprivacidade" element={<PoliticaPrivacidadePage />} />}
        {!camara && <Route path="/app/notasfiscais" element={<NotaFiscal config={config} />} />}
        {!camara && <Route path="/app/iptu" element={<IPTU config={config} />} />}
        {!camara && <Route path="/app/acessorapido" element={<TodasNoticias />} />}
        <Route path="/app/perguntas" element={<Contato />} />
        {!camara && <Route path="/turismo/bodenarua" element={<SaoJoao />} />}
        <Route path="/ticket/:ticketId" component={<TicketDetails />} />
        <Route path="/legislacao/codigotributario" element={<CodigoTributario />} />
        <Route path="/legislacao/decretos" element={<Decretos />} />
        {!camara && <Route path="/legislacao/aldir_blanc" element={<AldirBlanc />} />}
        {camara && <Route path="/mesadiretora" element={<Mesadiretora />} />}
        <Route path="/legislacao/diariosoficial" element={<DiarioOficial />} />
        <Route path="/legislacao/requerimentos" element={<Requerimentos />} />
        <Route path="/legislacao/leiorganica" element={<LeiOrganica />} />
        <Route path="/legislacao/projetodelei" element={<ProjetoDeLei />} />
        <Route path="/legislacao/decretos_legislativos" element={<DecretosLegislativos />} />
        <Route path="/legislacao/mocoes" element={<Mocoes />} />
        <Route path="/legislacao/atas" element={<Atas />} />
        <Route path="/legislacao/emendas_parlamentares" element={<EmendasParlamentares />} />
        <Route path="/legislacao/resolucoes" element={<Resolucoes />} />
        <Route path="/legislacao/indicacoes" element={<Indicacoes />} />
        <Route path="/legislacao/pareceres" element={<Pareceres />} />
        <Route path="/legislacao/pedidos_info" element={<Pedidos />} />
        <Route path="/legislacao/leismunicipais" element={<LeisMunicipais />} />
        <Route path="/legislacao/portarias" element={<Portarias />} />
        <Route path="/legislacao/controleinterno" element={<ControleInterno />} />
        <Route path="/licitacoes" element={<Licitacoes />} />
        <Route path="/arquivos/editais" element={<Editais />} />
        <Route path="/arquivos/contratos" element={<Contratos />} />
        <Route path="/arquivos/ldo" element={<LDO />} />
        <Route path="/arquivos/concursos" element={<ConcursoPublico />} />
        <Route path="/arquivos/loa" element={<LOA />} />
        <Route path="/arquivos/rgf" element={<RGF />} />
        <Route path="/arquivos/tabela-diarias" element={<TabelaDiariasMunicipais />} />
        <Route path="/arquivos/pca" element={<PCA />} />
        <Route path="/arquivos/ppa" element={<PPA />} />
        <Route path="/arquivos/rreo" element={<RREO />} />
        <Route path="/arquivos/frota" element={<Frota />} />
        <Route path="/arquivos/semanario" element={<Semanario />} />
        <Route path="/arquivos/quadro" element={<Quadro />} />
        <Route path="/arquivos/licitacoes" element={<ArqLicitacoes />} />
        <Route path="/arquivos/farmaciabasica" element={<FarmaciaBasica />} />
        {/* {!camara && <Route path="/secretarias/financas" element={<Financas />} />}
        {!camara && <Route path="/secretarias/infraestrutura" element={<Infraestrutura />} />}
        {!camara && <Route path="/secretarias/educacao" element={<Educacao />} />}
        {!camara && <Route path="/secretarias/administracao" element={<Administracao />} />}
        {!camara && <Route path="/secretarias/cultura" element={<Cultura />} />}
        {!camara && <Route path="/secretarias/meioambiente" element={<MeioAmbiente />} />}
        {!camara && <Route path="/secretarias/desenvolvimentorural" element={<DesenvolvimentoRural />} />}
        {!camara && <Route path="/secretarias/assistenciasocial" element={<AssistenciaSocial />} />}
        {!camara && <Route path="/setor/recursoshumanos" element={<Rh />} />} */}
        {/* {!camara && <Route path="/prefeitura/prefeito" element={<Prefeito />} />} */}
        <Route path="/e-sic" element={<ESICPage />} />
        <Route path="/galeria" element={<GaleriaMidiaPage />} />
        <Route path="/lgpd" element={<LgpdInfoPage />} />
        <Route path="/politica-de-privacidade" element={<LgpdInfoPage />} />
        <Route path="/carta-de-servico" element={<ServiceLetterPage />} />
        <Route path="/ouvidoria" element={<OuvidoriaPage />} />

        <Route path="/galeria-presidentes" element={<GaleriaPresidentes />} />
        {/* {!camara && <Route path="/prefeitura/viceprefeito" element={<VicePrefeito />} />} */}
        <Route path="/historia" element={<HistoriaGurjaoPage config={config} />} />
        <Route path="*" element={<PaginaNaoEncontrada />} />
        <Route path="/arquivos/:tipo" element={<Arquivos />} />
        <Route path="/pagina/:pageName" element={<DynamicPage />} />
      </Routes>

      <Footer config={config} />
    </Router>
  );
}

export default App;
